import { createSlice } from '@reduxjs/toolkit';

import { fetcherInitialState } from '../fetcher';
import { DocumentTypesFetcher } from './thunk';

const initialState = fetcherInitialState;

export const documentTypesSlice = createSlice({
    name: 'documentTypes',
    initialState,
    reducers: {},
    extraReducers(builder) {
        DocumentTypesFetcher.reducers(builder);
    },
});

export default documentTypesSlice.reducer;
